<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Exames"
    >
        <Form 
            :regulador="regulador" 
            :exame="exameEdit"
            @exameUpdate="handleExameUpdate"
        />

        <List
            :data="data"
            :regulador="regulador"
            @exameEdit="handleExameEdit"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { object } from '@/mixins'

export default {
    components: { Form, List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalRegulador: null,
        regulador: null,
        exameEdit: null
    }),
    methods: {
        open(regulador) {

            this.originalRegulador = regulador
            this.regulador = this.clone(regulador)
            this.exameEdit = null
            
            this.$refs.Modal.show()
        },
        save() {

            this.originalRegulador.exames = this.regulador.exames
            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        },
        handleExameEdit(exame) {

            this.exameEdit = exame
        },
        handleExameUpdate() {

            this.exameEdit = null
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>